import { Link } from 'react-router-dom';
import { Star, ChevronRight } from 'lucide-react';

/**
 * PROMO BANNER (temporary) — light-yellow strip at the top of Home linking to /concurso-agencias-conocidas.
 * Sits right below the fixed 52px nav. Remove from Home.tsx when the promo ends.
 */
export function ConcursoBanner() {
  return (
    <Link
      to="/concurso-agencias-conocidas"
      className="group block mt-[52px] -mb-[52px] relative z-40 bg-amber-100 hover:bg-amber-200/80 transition-colors"
    >
      <div className="mx-auto w-full max-w-[1120px] px-6 sm:px-8">
        <p className="flex items-center justify-center gap-2 py-2.5 text-sm font-medium text-amber-900 text-center">
          <Star className="w-4 h-4 fill-amber-500 text-amber-500 shrink-0" />
          <span>
            <span className="font-semibold">Concurso:</span>{' '}
            valora tu agencia de envíos y participa.
          </span>
          <span className="hidden sm:inline-flex items-center font-semibold">
            Participar
            <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
          </span>
        </p>
      </div>
    </Link>
  );
}
